module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_qa-9ca6a38dae414d22fb463089ce17cad9.svg";